import { render, staticRenderFns } from "./PermissionsView.vue?vue&type=template&id=3a9b4726&scoped=true&"
import script from "./PermissionsView.vue?vue&type=script&lang=js&"
export * from "./PermissionsView.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsView.vue?vue&type=style&index=0&id=3a9b4726&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9b4726",
  null
  
)

export default component.exports